// extracted by mini-css-extract-plugin
export default {"brandPromo":"KL-z","carousel":"LL-z"};